import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-listado-empresa',
  templateUrl: './listado-empresa.component.html'
})
export class ListadoEmpresaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
